module.exports = __webpack_public_path__ + "img/geography.27404ac0.png";